import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  errorMessage: IErrorMessage | null;
  successMessage: string | null;
  tripsPageFilterOption: string;
}

export const initialState: UIState = {
  errorMessage: null,
  successMessage: null,
  tripsPageFilterOption: '1',
};

export interface IErrorMessage {
  primaryMessage: string;
  secondaryMessage?: string;
}

export const slice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setErrorMessage: {
      reducer(state: UIState, action: PayloadAction<IErrorMessage>) {
        state.errorMessage = action.payload;
      },
      prepare(primaryMessage: string, secondaryMessage?: string) {
        return {
          payload: {
            primaryMessage,
            secondaryMessage,
          },
        };
      },
    },
    setSuccessMessage: (
      state: UIState,
      action: { type: string; payload: string },
    ) => {
      state.successMessage = action.payload;
    },
    clearMessages: (state: UIState, action: { type: string }) => {
      state.errorMessage = null;
      state.successMessage = null;
    },
    setTripsPageFilterOption: (
      state: UIState,
      action: { type: string; payload: string },
    ) => {
      state.tripsPageFilterOption = action.payload;
    },
  },
});

export const { setErrorMessage } = slice.actions;
export const { setSuccessMessage } = slice.actions;
export const { clearMessages } = slice.actions;
export const { setTripsPageFilterOption } = slice.actions;

export const selectErrorMessage = (state: { ui: UIState }) =>
  state.ui.errorMessage;

export const selectSuccessMessage = (state: { ui: UIState }) =>
  state.ui.successMessage;

export const selectTripsPageFilterOption = (state: { ui: UIState }) =>
  state.ui.tripsPageFilterOption;

export default slice.reducer;
